import React from "react";
import { Flex, Tag, Text } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import useCustomTheme from "../../hooks/useCustomTheme";

const TabLinkItem = ({ to, icon: Icon, label }) => {

  const theme = useCustomTheme();

  return (
    <Tag
      as={NavLink}
      size={"lg"}
      to={to}
      style={({ isActive }) => ({
        color: isActive ? "brand.700" : "grey.700",
      })}
      end
    >
      {({ isActive }) => (
        <Flex alignItems="center" gap={1}
        >
          <Icon size={16} color={isActive ? theme.colors.brand[600] : theme.colors.grey[400]} />
          <Text
            color={isActive ? "brand.700" : "grey.500"}
            _hover={{ color: isActive ? "brand.700" : "grey.700" }}
            fontWeight="500"
          >
            {label}
          </Text>
        </Flex>
      )}
    </Tag>
  );
};

export default TabLinkItem;
